/**
 * Section Component Variants
 *
 * CVA variants for the Section component.
 * Separated to allow React Fast Refresh to work properly.
 */

import {cva} from 'class-variance-authority';

// =============================================================================
// VARIANTS
// =============================================================================

export const sectionVariants = cva("w-full", {
  variants: {
    /**
     * Background color using design tokens
     * All colors reference semantic tokens from tokens.css
     */
    background: {
      transparent: "bg-transparent",
      default: "bg-background",
      muted: "bg-muted/30",
      surface: "bg-card",
      primary: "bg-primary/10",
      secondary: "bg-secondary/10",
      accent: "bg-accent/10",
    },
    /**
     * Vertical rhythm (padding) for section spacing
     * Uses Tailwind spacing scale tokens
     */
    spacing: {
      none: "py-0",
      xs: "py-4 sm:py-6",
      sm: "py-6 sm:py-8",
      md: "py-8 sm:py-12 lg:py-16",
      lg: "py-12 sm:py-16 lg:py-20",
      xl: "py-16 sm:py-20 lg:py-28",
      "2xl": "py-20 sm:py-28 lg:py-36",
    },
    /**
     * Border styles for visual separation
     */
    border: {
      none: "",
      top: "border-t border-border",
      bottom: "border-b border-border",
      both: "border-y border-border",
    },
    /**
     * Full viewport height (for hero sections)
     */
    fullHeight: {
      true: "min-h-screen",
      false: "",
    },
  },
  defaultVariants: {
    background: "transparent",
    spacing: "md",
    border: "none",
    fullHeight: false,
  },
});
